import { createContext } from 'react';
import { observable, runInAction } from 'mobx';

/**
 * Number of active column filters in the enclosing DataGrid.
 * Provided to the grid's `toolbar`; undefined when rendered outside a DataGrid.
 */
export const DataGridFilterContext = createContext<number | undefined>(undefined);

/**
 * Active filter count of every mounted DataGrid, keyed by grid instance.
 * Lets a FilterButton rendered outside the grid (e.g. in a tab bar) know whether anything is filtered.
 */
export const activeGridFilterCounts = observable.map<number, number>();

let nextGridId = 1;
export const nextDataGridId = () => nextGridId++;

export const countActiveFilters = (filterModel: object | null | undefined) =>
  filterModel ? Object.keys(filterModel).length : 0;

export const setGridFilterCount = (gridId: number, count: number) =>
  runInAction(() => {
    if (count > 0) {
      activeGridFilterCounts.set(gridId, count);
    } else {
      activeGridFilterCounts.delete(gridId);
    }
  });

export const clearGridFilterCount = (gridId: number) =>
  runInAction(() => {
    activeGridFilterCounts.delete(gridId);
  });

export const getTotalActiveGridFilters = () =>
  Array.from(activeGridFilterCounts.values()).reduce((total, count) => total + count, 0);
